<template>
  <div>
    <v-container fluid pa-0 grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title>
              <h2 class="headline mr-2">Manage Whitelist IPs</h2>
              <v-spacer />
              <v-text-field
                v-if="range"
                v-model="startIp"
                label="Starting IP"
                single-line
                hide-details
                :color="appButtonColor"
                class="mr-3"
                @keyup.enter="addAddress"
              />
              <v-text-field
                v-model="ipVal"
                :label="range ? 'Ending IP' : 'Add New IP'"
                single-line
                hide-details
                :color="appButtonColor"
                @keyup.enter="addAddress"
              >
              <template v-slot:append>
                <v-switch
                  :color="appButtonColor"
                  hide-details
                  class="mr-3"
                  v-model="range"
                  label="Range"
                ></v-switch>
                <v-icon :color="appButtonColor" @click="addAddress">add_circle</v-icon>
              </template>
              </v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="ips"
              :rows-per-page-items="[15]"
              class="elevation-1 table-striped my-3"
              :loading="searchLoading ? appButtonColor : searchLoading"
              :no-data-text="loadingText"
              item-key="address"
            >
              <template slot="items" slot-scope="props">
                <tr class="row">
                  <td>{{ props.item.address }}</td>
                  <td>{{ props.item.createdAt | moment("MM/DD/YYYY - h:mm a") }}</td>
                  <td>{{ formatCidr(props.item.address) }}</td>
                  <td class="delete">
                    <v-icon color="red" @click="removeAddress(props.item.address)">cancel</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { Cidr, IpAddress, IpRange } from "cidr-calc";
export default {
  name: "Manage",
  data() {
    return {
      newIp: "",
      range: false,
      startIp: "",
      endIp: "",
      searchLoading: true,
      groupError: false,
      permSuccess: false,
      search: "",
      userPerms: ["Super", "Admin", "User"],
      headers: [
        { text: "Address", sortable: true, value: "address" },
        { text: "Created", sortable: true, value: "createdAt" },
        { text: "Range", value: "" },
        { text: "", value: "" },
      ]
    };
  },
  computed: {
    ...mapState("user", ["user", "state", "confirmed", "mersBranded"]),
    ...mapState("accounts", ["ips"]),
    ...mapGetters("user", ["isAuthenticated", "userGroup", "adminOrSuper"]),
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0B2A4A";
    },
    ipVal: {
      get() {
        return this.range ? this.endIp : this.newIp;
      },
      set(val) {
        if (this.range) this.endIp = val
        else this.newIp = val
      }
    },
    formatDate(date) {},
    loadingText() {
      if (this.searchLoading) return "Loading Whitelist IPs";
      else return "No Whitelist IPs Found";
    },
    allIps() {
      return this.ips.map(item => item.address)
    }
  },
  async created() {
    await this.$store.dispatch("accounts/getIps");
    this.searchLoading = false;
  },
  methods: {
    formatCidr(val) {
      if (val.includes("/")) {
        let [ip, cidr] = val.split("/")
        let ipRange = new Cidr(IpAddress.of(ip), cidr)
        return ipRange.toIpRange()
      }
      else return "NA"
    },
    async addAddress() {
      let res;
      if (this.range) {
        if (!this.startIp || !this.endIp) return
        let range = new IpRange(IpAddress.of(this.startIp), IpAddress.of(this.endIp))
        let cidrs = range.toCidrs()
        let full = cidrs.map(item => {
          return `${item.prefix.toString()}/${item.prefixLen}`
        })
        let all = await Promise.all(full.map(item => {
          return this.$store.dispatch("accounts/newIp", item)
        }))
        res = all.every(Boolean)
      }
      else {
        if (this.allIps.includes(this.newIp)) {
          this.displayNotification("error", "IP Address Already Exists")
          return
        }
        res = await this.$store.dispatch("accounts/newIp", this.newIp)
      }
      
      if (res) {
        this.displayNotification("success", "IP Address/Addresses Added");
        this.newIp = ""
        this.startIp = ""
        this.endIp = ""
      } else {
        this.displayNotification("error", "Error Adding IP Address/Addresses");
      }
    },
    displayNotification(type, notification) {
      if (type === "success") {
        this.$snotify[type](`${notification}`);
      } else {
        this.$snotify[type](`${notification}`, "");
      }
    },
    async removeAddress(address) {
        let res = await this.$store.dispatch("accounts/removeIp", address);
        if (res) {
            this.displayNotification("success", "IP Address Removed");
        } else {
            this.displayNotification("error", "Error Removing IP Address");
        }
    },
  },
};
</script>

<style lang="scss">
.delete {
  text-align: right;
}
.v-input--switch {
  margin: 0;
  padding: 0;
}
</style>
